import { render, staticRenderFns } from "./UserProfileClientRefNo.vue?vue&type=template&id=14ab1280&scoped=true&"
import script from "./UserProfileClientRefNo.vue?vue&type=script&lang=js&"
export * from "./UserProfileClientRefNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab1280",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VContainer,
  VFlex,
  VForm,
  VLayout,
  VProgressCircular,
  VSpacer,
  VTextField,
})
